export var isBrowser = typeof window !== 'undefined';
var hasNodeEnv = function hasNodeEnv(env) {
  return DRIFT_ELECTRON_ENVIRONMENT === env;
};
var hasWindowEnv = function hasWindowEnv(env) {
  return isBrowser && window.__ENV__ === env;
};
export var isProduction = isBrowser ? hasWindowEnv('PRODUCTION') : hasNodeEnv('production');